/**
 * Web references to repository-exported assets (Section 6.1). Paths point at
 * `public/media`, populated from `assets/` by scripts/sync-web-assets.mjs. GLB
 * node names mirror the Blender export contract consumed by the reveal scene
 * (R-PRODUCT-04, MIST-0406). Nothing here embeds a private local source path
 * (R-ARCH-05, R-ASSET QA).
 */
export const POSTER = {
  desktop: {
    avif: '/media/product/mist-reveal-poster-desktop.avif',
    webp: '/media/product/mist-reveal-poster-desktop.webp',
    width: 1280,
    height: 720,
  },
  mobile: {
    avif: '/media/product/mist-reveal-poster-mobile.avif',
    webp: '/media/product/mist-reveal-poster-mobile.webp',
    width: 720,
    height: 900,
  },
} as const

export const PRODUCT_TRANSPARENT = {
  avif: '/media/product/mist-edition-001-transparent.avif',
  webp: '/media/product/mist-edition-001-transparent.webp',
  src: '/media/product/mist-edition-001-transparent.png',
  width: 900,
  height: 1100,
} as const

/** Art-directed mineral dune horizon (MIST-0403, ReviewWebVisuals I1). */
export const DUNE_HORIZON = {
  avif: '/media/experience/mist-dune-horizon.avif',
  webp: '/media/experience/mist-dune-horizon.webp',
  src: '/media/experience/mist-dune-horizon.png',
  width: 1600,
  height: 480,
} as const

export const REVEAL_GLB = '/media/3d/mist-edition-template.glb'

/**
 * The Blender export's named nodes (asset-manifest geometry.nodes), read by the
 * Edition 001 live view and the continuum scene.
 */
export const GLB_NODES = {
  sleeve: 'Sleeve',
  tray: 'Tray',
  insert: 'Insert',
  bottle: 'Bottle',
  liquid: 'Liquid',
  collar: 'Collar',
  cap: 'Cap',
  label: 'Label',
} as const

/**
 * The six Scent Continuum phases, in scroll order (R-MOTION-02, MIST-0408). The
 * ids mirror `ScentContinuumChapter`; the labels drive the phase index beside the
 * pinned product and remain in the DOM as the semantic fallback caption.
 */
export const CONTINUUM_PHASES = [
  { id: 'terrain', label: 'Dune field' },
  { id: 'condensation', label: 'Condensation' },
  { id: 'sleeve', label: 'The sleeve draws back' },
  { id: 'rise', label: 'The tray lifts, the bottle rises' },
  { id: 'breath', label: 'A held breath' },
  { id: 'possession', label: 'Peridot in hand' },
] as const
